import { createTheme, ThemeProvider } from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { Provider } from "react-redux";
import { 
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Navbar from "./components/NavBar";

import { store } from "./store";
import LoginPage from "./views/AuthenticationView/pages/LoginPage";
import RegisterPage from "./views/AuthenticationView/pages/RegisterPage";
import DashboardPage from "./views/DashboardView/pages/DashboardPage";

import AddInfoPage from "./views/NewProjectView/pages/AddInfoPage";
import AddTitlePage from "./views/NewProjectView/pages/AddTitlePage";
import CategoryChoicePage from "./views/NewProjectView/pages/CategoryChoicePage";
import HomePage from "./views/ProjectStoreView/pages/HomePage";
import ProjectPresentationPage from "./views/ProjectStoreView/pages/ProjectPresentationPage";


const theme = createTheme({
  palette: {
    primary: {
      main: '#46bda7',
    },
    secondary: {
      main: '#002f4f',
    },
    danger: {
      main: red[500]
    },
    grey: {
      main: grey[500]
    }
  },
});

function App() {
  return (
    <Provider store={store}>
    <ThemeProvider theme={theme}>
      <div className="App">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage/>} />
            <Route path="/ajouter-titre" element={<AddTitlePage/>} />
            <Route path="/choix-categorie" element={<CategoryChoicePage/>} />
            <Route path="/ajouter-infos-projet" element={<AddInfoPage/>} />
            <Route path="/presentation-projet" element={<ProjectPresentationPage/>} />
            <Route path="/login" element={<LoginPage/>} />
            <Route path="/register" element={<RegisterPage/>} />
            <Route path="/dashboard" element={<DashboardPage/>} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
    </Provider>
  );
}

export default App;
